import AddLocationModal from './AddLocationModal'

export default AddLocationModal;